import { useContext } from 'react'

import AppContext from 'contexts/AppContext'

export const settingTypes = Object.freeze({
  AUTOMATIC_AI_NOTE_DELETION: 'automatic_ai_note_deletion',
  DEFAULT_APPOINTMENTS_VIEW: 'default_appointments_view',
  DEFAULT_TAB: 'default_tab',
  ENCOUNTER_LABEL: 'encounter_label',
  LOCATION_LABEL: 'location_label',
  SCHEDULE_LIST_LABEL: 'schedule_list_label',
  SCHEDULE_SURGERIES_LABEL: 'schedule_surgeries_label',
  HAS_SIDEBAR_COLLAPSED: 'has_sidebar_collapsed',
  AUTOMATICALLY_SEND_OP_REPORT: 'automatically_send_op_report',
  MANAGE_OPERATIVE_NOTE_IMAGES: 'manage_operative_note_images',
  AUTOMATICALLY_FAX_OP_REPORT: 'automatically_fax_op_report',
  PROFILE_PREFERENCES: 'profile_preferences',
  AI_NOTES_SPEECH_MODE: 'ai_notes_speech_mode',
  FORMAT_AI_NOTES: 'format_ai_notes',
  INCLUDE_AI_DISCLAIMER: 'include_ai_disclaimer',
  AI_DISCLAIMER_TEXT: 'ai_disclaimer_text',
  PATIENT_REFERENCE: 'patient_reference',
  LISTEN_FOR_VOICE_COMMANDS: 'listen_for_voice_commands',
  EXPECT_IMAGES_BEFORE_SIGNOFF: 'expect_images_before_sign_off',
  DISPLAY_REAL_TIME_TRANSCRIPTION: 'display_real_time_transcription',
  MANUALLY_APPLY_EDITS_TO_FUTURE_NOTES: 'manually_apply_edits_to_future_notes',
  AUTOMATICALLY_APPLY_EDITS_TO_FUTURE_NOTES:
    'automatically_apply_edits_to_future_notes'
})

const useSetting = settingType => {
  const { resolvedSettings } = useContext(AppContext)

  return resolvedSettings && resolvedSettings[settingType]
}

export const useAccountSetting = (account, settingType) =>
  account?.resolvedSettings?.[settingType]

export default useSetting
